module.exports = __webpack_public_path__ + "img/3.193db2e0.jpg";